import { Map } from 'immutable';

import { CLEAR_QUIZ_STATE, SET_QUIZ_STATE, SET_PREVIOUS_QUIZ_RESULTS } from './actions';

export const QUIZ_KEY = 'quiz';
export const QUIZ_RESULTS_KEY = 'results';
export const QUIZ_STAGE_KEY = 'stage';
export const QUIZ_REWARDS_KEY = 'rewards';

export function quizReducer(state = Map(), action) {
    switch (action.type) {
        case SET_QUIZ_STATE:
            // Set the state of the quiz indexed by the taskId.
            return state.setIn([action.taskId, action.key], action.value);

        case CLEAR_QUIZ_STATE:
            // Clear the state of the quiz indexed by the taskId.
            return state.delete(action.taskId);

        case SET_PREVIOUS_QUIZ_RESULTS:
            // Store the previous results of the quizzes
            return state.set(QUIZ_RESULTS_KEY, action.results);
    }
    return state;
}
